import { createSelector } from 'reselect';
import { makeSelectShelvesSelectedLastHistory } from 'containers/Configurator/selectors/history';
import { Position, PositionAngle } from 'lib/modelBuilder/constants';
import { ColorPreviewItem } from 'containers/PanesPanel/selectors';
import {
  makeSelectHandleDoorSelectedColor,
  makeSelectHandleDrawerSelectedColor,
} from 'containers/HandlesPanel/selectors';

export const makeSelectCommonHandlerColors = () =>
  createSelector(
    makeSelectShelvesSelectedLastHistory(),
    makeSelectHandleDoorSelectedColor(PositionAngle.FrontLeft),
    makeSelectHandleDoorSelectedColor(PositionAngle.FrontRight),
    makeSelectHandleDoorSelectedColor(PositionAngle.BackLeft),
    makeSelectHandleDoorSelectedColor(PositionAngle.BackRight),
    makeSelectHandleDrawerSelectedColor(Position.Left),
    makeSelectHandleDrawerSelectedColor(Position.Right),
    makeSelectHandleDrawerSelectedColor(Position.Front),
    (
      shelves,
      doorFL,
      doorFR,
      doorBL,
      doorBR,
      handleL,
      handleR,
      handleF,
    ): ColorPreviewItem[] | undefined => {
      let colors: ColorPreviewItem[] = [];
      let doors = true;
      let fourDoors = false;
      let drawers = true;
      for (const shelf of shelves) {
        if (shelf.doors.length === 0) {
          doors = false;
        }
        if (shelf.doors.length > 2) {
          fourDoors = true;
        }
        if (shelf.drawers.length === 0) {
          drawers = false;
        }
      }
      if (doors && drawers) {
        return undefined;
      }
      if (doors) {
        if (doorFL) colors.push(doorFL[0]);
        else colors.push(undefined);
        if (doorFR) colors.push(doorFR[0]);
        else colors.push(undefined);
        if (fourDoors) {
          if (doorBL) colors.push(doorBL[0]);
          else colors.push(undefined);
          if (doorBR) colors.push(doorBR[0]);
          else colors.push(undefined);
        }
      }
      if (drawers) {
        if (shelves[0].cabinet.width >= 600) colors = [handleL, handleR];
        else colors = [handleF];
      }
      return colors;
    },
  );

export const makeSelectCommonPaneColors = (position: Position) =>
  createSelector(makeSelectShelvesSelectedLastHistory(), (shelves):
    | ColorPreviewItem
    | undefined => {
    // let colors: ColorPreviewItem[] = [];
    let color: ColorPreviewItem | undefined = undefined;
    for (const shelf of shelves) {
      for (const rack of shelf.racks) {
        const pane = rack.getPane(position);
        if (pane) {
          if (color && color.reference !== pane.color.reference)
            return undefined;
          else {
            color = pane.color;
          }
        }
      }
    }
    return color;
  });

export const makeSelectCommonPlateColors = () =>
  createSelector(makeSelectShelvesSelectedLastHistory(), (shelves):
    | ColorPreviewItem
    | undefined => {
    let color: ColorPreviewItem | undefined = undefined;
    let glass: boolean | undefined = undefined;
    for (const shelf of shelves) {
      for (const rack of shelf.racks) {
        if (rack.plate) {
          if (color && color.reference !== rack.plate.color.reference)
            return undefined;
          else if (glass && !rack.glassPlate) {
            return undefined;
          } else if (glass === false && rack.glassPlate) {
            return undefined;
          } else {
            color = rack.plate.color;
            glass = !!rack.glassPlate;
          }
        }
      }
    }
    return color;
  });

export const makeSelectCommonGlassPlate = () =>
  createSelector(makeSelectShelvesSelectedLastHistory(), (shelves): boolean => {
    for (const shelf of shelves) {
      if (!shelf.rack(0).glassPlate) {
        return false;
      }
    }
    return true;
  });

export const makeSelectCanAddIs = () =>
  createSelector(makeSelectShelvesSelectedLastHistory(), (shelves): boolean => {
    for (const shelf of shelves) {
      if (shelf.height >= 200) return true;
    }
    return false;
  });
